// external imports
import React from 'react'
import { FlexRow } from 'quark-web'
import { graphql } from 'react-relay'
// local imports
// import styles from './styles'
import Content from './PrintProductContent'
import { QueryRenderer } from '~/components'

const PrintProduct = ({ id }) => (
    <QueryRenderer
        query={graphql`
            query PrintProductQuery($id: ID!) {
                product: node(id: $id) {
                    ...PrintProductContent_product
                }
            }
        `}
        variables={{
            id
        }}
        render={data => data && <Content product={data.product} />}
    />
)

export default PrintProduct



// WEBPACK FOOTER //
// ./src/views/PrintProduct/index.js